export default (props) => (
  <svg {...props} width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.44 9.79 8.21 11.39.6.11.82-.26.82-.57 0-.28-.02-1.23-.02-2.24-3.01.56-3.79-.73-4.03-1.41-.14-.34-.72-1.41-1.23-1.69-.42-.23-1.02-.78-.01-.8.94-.01 1.62.87 1.85 1.23.87 1.82 2.8 1.31 3.5 1.0.1-.78.42-1.31.77-1.61-2.67-.3-5.46-1.33-5.46-5.93 0-1.31.47-2.39 1.23-3.22-.12-.3-.54-1.53.12-3.18 0 0 1-.32 3.3 1.23 1-.27 2.0-.41 3.03-.41s2.03.14 3.03.41c2.3-1.55 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.76.83 1.23 1.91 1.23 3.22 0 4.6-2.8 5.63-5.48 5.93.36.31.68.97.68 1.97 0 1.43-.02 2.89-.02 3.3 0 .31.22.68.82.57C20.56 21.79 24 17.31 24 12 24 5.37 18.63 0 12 0z"
    />
  </svg>
);
